import { useState } from "react";

import { makePostApiCall, makePutApiCall } from "../../../shared/makeApiCall";
import AllergensForm from "../../../components/forms/setup/allergens/AllergensForm";
import DeleteConfirmationForm from "../../../components/forms/DeleteConfirmationForm";
import { SnackbarData, SnackbarType } from "../../../components/Snackbar";
import { generateUniqueNumber } from "../../../shared/utility";

export function AllergensViewModel(logout, addSnackbar) {
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [allergens, setAllergens] = useState({ data: [] });
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });

  const user_id = localStorage.getItem("id");

  const getAllergens = async function (search, page) {
    setLoading(true);
    const payload = {
      page: page,
      search: search,
    };
    let callResult = await makePostApiCall(`allergens`, payload);
    setLoading(false);
    if (callResult.success) {
      setAllergens(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const createAllergen = async function (values) {
    const payload = { ...values, user_id: user_id };
    let callResult = await makePostApiCall("createAllergen", payload);

    if (callResult.success) {
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          "Allergen added",
          SnackbarType.Success,
        ),
      );
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getAllergens("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const updateAllergen = async function (allergen, values, index) {
    let callResult = await makePutApiCall(`allergens/${allergen.id}`, values);

    if (callResult.success) {
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          "Allergen updated",
          SnackbarType.Success,
        ),
      );
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getAllergens("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const openAddAllergenSlideOver = () => {
    setSlideOver({
      childComponent: (
        <AllergensForm
          isEdit={false}
          setOpen={setSlideOver}
          actionCall={createAllergen}
        />
      ),
      open: true,
    });
  };

  const viewAllergenDetails = async function (allergen, index) {
    setSlideOver({
      childComponent: (
        <AllergensForm
          allergen={allergen}
          index={index}
          isEdit={true}
          setOpen={setSlideOver}
          actionCall={updateAllergen}
        />
      ),
      open: true,
    });
  };

  const deleteAllergen = async function (id, index) {
    setLoading(true);

    let callResult = await makePostApiCall(`deleteAllergen/${id}`, {});
    setLoading(false);
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });
      getAllergens(null, 0);

      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          callResult.data.message,
          SnackbarType.Success,
        ),
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const askDeleteAllergen = function (allergen, index) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => deleteAllergen(allergen.id, index)}
          message={`Are you sure you want to delete  ${allergen.name}?`}
          setOpen={setEmptyModelOpen}
        />
      ),
      open: true,
    });
  };

  return {
    askDeleteAllergen,
    emptyModal,
    getAllergens,
    loading,
    allergens,
    openAddAllergenSlideOver,
    setEmptyModelOpen,
    setSlideOver,
    slideOver,
    viewAllergenDetails,
  };
}
